import { AspectRatio, AspectRatioProps, Box, Image } from "@chakra-ui/react";
import TraitImage from "components/TraitImage";
import { publicUrl } from "config";

export type TraitsCanvasProps = {
  traits: number[];
  color: number;
  imagesSize?: "256" | "512" | "1024";
} & Omit<AspectRatioProps, "ratio" | "color">;

const TraitsCanvas = ({
  traits,
  color,
  imagesSize = "512",
  ...rest
}: TraitsCanvasProps) => {
  return (
    <AspectRatio ratio={1} w="full" bg="bright.300" {...rest}>
      <Box userSelect="none">
        <Image
          position="absolute"
          top="0"
          left="0"
          w="full"
          src={`${publicUrl}/bear-placeholder_transparent.png`}
        />

        {traits.map((tokenId) => (
          <TraitImage
            key={tokenId}
            tokenId={tokenId}
            color={color}
            size={imagesSize}
            position="absolute"
            top="0"
            left="0"
            w="full"
          />
        ))}
      </Box>
    </AspectRatio>
  );
};

export default TraitsCanvas;
